import { descriptions } from "./descrptions";
function getCode(description) {
    for (const entry of descriptions) {
        if (entry.greek === description || entry.english === description) {
            return entry.code;
        }
    }
    return "Code not found";
}

export default getCode;